import React, {useState, useEffect, useContext } from 'react';
import axios from '../Common/axios';
import {Button, Input, Modal, Select, Table, DatePicker} from "antd";
import CodeSelect from '../Common/CodeSelect';
import {getGridTableHeight, gatDateTimeFormatter, getNowDate, getNowAddMonthDate} from '../Common/util';
import {getFindLogList} from '../Common/api';
import {excelDownload} from '../Common/function';
import AppContext from '../../components/AppContext';
import Cookies from 'js-cookie';
import TopMenu from '../Common/TopMenu';
import {logTypeSelectOptions} from '../Common/options';
import SelectBox from '../Common/SelectBox';
import dayjs from 'dayjs';
import {getCodeName} from '../Common/CodeSelect';
import { getCodeList } from '../Common/codeManager';
import './LogList.css';

const {Option} = Select;
const { RangePicker } = DatePicker;

/** -------------------------------------------------------------------------- **/
const LogList = () => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken?true:false;

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [logType, setLogType] = useState('');
    const [logUser, setReportName] = useState('');
    const [startYmd, setStartYmd] = useState(getNowAddMonthDate(0,''));
    const [endYmd, setEndYmd] = useState(getNowDate(''));

    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    /** -------------------------------------------------------------------------- **/
    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);
        myContext.setCompanyCode(value);
        myContext.setCompanyName(option.children[2]);
    };

    // 로그구분 변경
    const onChangeLogType = (value) => {
        setLogType(value);
    };

    // 로그기간 변경
    const onChangeDateRange = (values, formatString) => {
        //console.log(formatString);
        if(formatString != null) {
            if( formatString.length >=1) {
                setStartYmd(formatString[0].replace(/[-]/g,''));
            }
            if( formatString.length >= 2) {
                setEndYmd(formatString[1].replace(/[-]/g,''));
            }
        }
    };

    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "logUser") {
            setReportName(event.target.value);
        } 
    };

    // 검색 클릭 시
    const onClickSearchHandler = () => {
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }
        // 로그일자 필수조건 체크
        if (startYmd == '' || endYmd == '') {
            Modal.info({title: "로그일자 조회기간은 필수 조회조건입니다."});
            return;
        }

        // 로그 조회
        findLogList();

    };

    // 로그 조회 API
    const findLogList = () => {
        // 회사코드가 없으면 조회하지 않음
        if (!companyCode) return;
        
        setIsLoading(true);
        axios.get(getFindLogList(companyCode,logType,logUser,startYmd,endYmd))
            .then((response) => {
                //console.log(response);
                setIsLoading(false);
                setDataSource(response.data);
                if(response.data.totalCount == 0) {
                    Modal.info({title: "No Data.", okText:"Close"});
                }
            })
            .catch((error) => {
                console.log("LogList.js --- 105 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    // 화면로딩시 자동조회
    useEffect(() => {
        // 코드 목록 새로고침
        getCodeList();
    }, []);
    
    // 회사코드 변경 시 자동 조회
    useEffect(() => {
        if (companyCode) {
            findLogList();
        }
    }, [companyCode]);

    // 로그_목록
    const logColumnData = [
        {
            title: '로그일자',
            dataIndex: 'log_date',
            key: 'log_date',
            align: 'center',
            sorter: {
                compare: (a, b) => a.log_date.localeCompare(b.log_date),
            },
            render: (_ , rowData ) => {
                return (
                    gatDateTimeFormatter(rowData.log_date)
                );
            },
        },
        {
            title: '로그구분',
            dataIndex: 'log_type',
            key: 'log_type',
            align: 'center',
            sorter: {
                compare: (a, b) => a.log_type.localeCompare(b.log_type),
            },
            render: (_ , rowData ) => {
                return (
                    getCodeName('logType', rowData.log_type)
                );
            },
        },
        {
            title: '사용자',
            dataIndex: 'log_user',
            key: 'log_user',
            align: 'center',
            sorter: {
                compare: (a, b) => a.log_user.localeCompare(b.log_user),
            },
        },
        {
            title: 'IP',
            dataIndex: 'log_ip',
            key: 'log_ip',
            align: 'center',
        },
        {
            title: 'URL',
            dataIndex: 'log_url',
            key: 'log_url',
            align: 'left',
            ellipsis : true,
            width: 80,
        },
        {
            title: '파라미터',
            dataIndex: 'log_param',
            key: 'log_param',
            align: 'left',
            ellipsis : true,
            width: 80,
        },
        {
            title: '내용',
            dataIndex: 'log_desc',
            key: 'log_desc',
            align: 'left',
            ellipsis : true,
        },
    ];

    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <TopMenu selectKey='log' />
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'25%'}} />
                        <col style={{width:'6%'}} />
                        <col style={{width:'16%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>
                            <CodeSelect codeType="com_cd" 
                                        id="companyCode"
                                        value={companyCode}
                                        disabled={authenticated?true:false}
                                        onChangeHandler={onChangeCompanyCode}
                            />
                        </td>
                        <th><span className='req'>*</span>로그일자</th>
                        <td>
                            <RangePicker id="logYmd" size="small" 
                                defaultValue={[dayjs(getNowAddMonthDate(0,'-')), dayjs(getNowDate('-'))]}
                                onChange={onChangeDateRange}
                            />
                        </td>
                        <th>로그구분</th>
                        <td>
                            <SelectBox id="logType"
                                        options={logTypeSelectOptions}
                                        value={logType}
                                        onChangeHandler={onChangeLogType}      
                            />
                        </td>
                        <th>사용자</th>
                        <td>
                            <Input id="logUser" size="small"
                                   allowClear
                                   value={logUser}
                                   onChange={onChangeInputHandler}
                                   onPressEnter={onClickSearchHandler}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className="search_button">
                    <Button type="default" onClick={onClickSearchHandler}>조회</Button>
                </div>
            </div>
            <div className="section">
                <table style={{width:'100%'}}><tbody>
                  <tr>
                    <td><div style={{marginLeft:'20px'}}>총 {dataSource?.length} 개</div></td>
                    <td style={{textAlign:'right'}}>
                        <Button type="default" onClick={()=> excelDownload('로그 목록', dataSource)}> Excel Download</Button>
                    </td>
                  </tr></tbody>
                </table>
                <Table className="log-list-table"
                       columns={logColumnData}
                       dataSource={dataSource}
                       rowKey="log_date"
                       scroll={{x: 'max-content', y: getGridTableHeight(360)}}
                       loading={{
                           size: "large",
                           spinning: isLoading
                         }}
                       pagination={{position: ['bottomCenter'], defaultPageSize:[100]}}
                       bordered size={"small"}
                       style={{height:getGridTableHeight(320)}}
                       showSorterTooltip={false}
                       tableLayout="auto"
                />
            </div>
        </>
    );
}
export default LogList;